import { ItemList } from '../orm'

class DropdownOptions extends ItemList {

    constructor(dropdown_name) {
        super(`photographer_options__${dropdown_name}`)
        this.url = `photographer/dropdown_options/${dropdown_name}`
    }

    getEntityKey() {
        return this.url
    }
}

export const sportTagsDropdownOptions = new DropdownOptions('sport_tags')
export const shotAtDateDropdownOptions = new DropdownOptions('shot_at_dates')
export const shotAtTimeDropdownOptions = new DropdownOptions('shot_at_times')
export const sessionNameDropdownOptions = new DropdownOptions('session_names')
export const activityTagDropdownOptions = new DropdownOptions('activity_tags')
export const genreTagDropdownOptions = new DropdownOptions('get_all_genre_tags')
export const albumDropdownOptions = new DropdownOptions('get_all_albums')
export const galleryEventDropdownOptions = new DropdownOptions('get_all_gallery_events')
